import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import { useState, lazy, Suspense } from 'react';
import { Button, Col, Container, Form, InputGroup, Modal, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './App.scss';
import BalanceModal from './components/BalanceModal';
import BlockDAGBox from './components/BlockDAG';
import CoinsupplyBox from './components/CoinsupplyBox';
import MarketDataBox from './components/MarketDataBox';
import { getBlock } from './vecno-api-client';
import { ADDRESS_PREFIX, SUFFIX } from './explorer_constants';

const BlockOverview = lazy(() => import('./components/BlockOverview'));
const TxOverview = lazy(() => import('./components/TxOverview'));

function Dashboard() {
    const [show, setShow] = useState(false);
    const [showLoadingModal, setShowLoadingModal] = useState(false);
    const navigate = useNavigate();
    const handleClose = () => setShow(false);
    const [balance] = useState(0);
    const [address] = useState(ADDRESS_PREFIX);

    const search = (e) => {
        e.preventDefault();
        const v = e.target.searchInput.value;
        setShowLoadingModal(true);

        if (v.length === 64) {
            getBlock(v)
                .then((data) => {
                    if (data.detail === 'Block not found') {
                        navigate(`/txs/${v}`);
                    } else {
                        navigate(`/blocks/${v}`);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching block:', err);
                })
                .finally(() => {
                    setShowLoadingModal(false);
                });
        } else if (v.startsWith(ADDRESS_PREFIX)) {
            navigate(`/addresses/${v}`);
            setShowLoadingModal(false);
        } else {
            setShowLoadingModal(false);
        }
    };

    return (
        <div className="dashboard-page">
            <Modal
                show={showLoadingModal}
                animation={false}
                centered
                aria-labelledby="loading-modal"
                className="loading-modal"
            >
                <Modal.Body
                    className="d-flex flex-row justify-content-center"
                    style={{ backgroundColor: '#181D30' }}
                >
                    <Spinner animation="border" variant="primary" size="xl" aria-label="Loading" />
                </Modal.Body>
            </Modal>
            <div className="row1 header-section">
                <Container className="firstRow webpage" fluid>
                    <Row className="align-items-center">
                        <Col
                            xs={12}
                            md={12}
                            className="d-flex flex-row justify-content-center text-light align-items-center"
                        >
                            <img className="big-vecno-icon" src="/k-icon-glow.png" alt="VECNO logo" />
                            <div className="bigfont kas-badge">
                                <span className="vecno-part">VECNOSCAN</span>
                                <span className="suffix-part">{SUFFIX}</span>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={10} lg={8} className="mx-auto text-center">
                            <h2 className="hero-tagline">Search the blockchain</h2>
                            <Form onSubmit={search} className="search-container" aria-label="Search blockchain">
                                <InputGroup>
                                    <Form.Control
                                        name="searchInput"
                                        type="search"
                                        placeholder={`Search for ${ADDRESS_PREFIX}address, block, or transaction`}
                                        aria-label="Search input"
                                        className="shadow-none"
                                    />
                                    <Button
                                        type="submit"
                                        className="shadow-none searchButton"
                                        variant="dark"
                                        aria-label="Submit search"
                                    >
                                        <i className="fa fa-search" />
                                    </Button>
                                </InputGroup>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="row2">
                <Container className="secondRow webpage" fluid>
                    <Row className="info-boxes">
                        <Col sm={12} md={6} xl={4} className="mb-4">
                            <div className="info-box-wrapper">
                                <CoinsupplyBox />
                            </div>
                        </Col>
                        <Col sm={12} md={6} xl={4} className="mb-4">
                            <div className="info-box-wrapper accent">
                                <BlockDAGBox />
                            </div>
                        </Col>
                        <Col sm={12} md={6} xl={4} className="mb-4">
                            <div className="info-box-wrapper">
                                <MarketDataBox />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="row4">
                <Container className="fourthRow webpage" fluid>
                    <Row>
                        <Col xs={12} lg={6}>
                            <div className="table-card">
                                <h3 className="section-header">Recent Blocks</h3>
                                <Suspense fallback={<div className="text-center py-2"><Spinner animation="border" size="sm" variant="primary" /></div>}>
                                    <BlockOverview lines={window.innerWidth <= 576 ? 6 : 12} small />
                                </Suspense>
                            </div>
                        </Col>
                        <Col xs={12} lg={6} className="mt-5 mt-lg-0">
                            <div className="table-card">
                                <h3 className="section-header">Recent Transactions</h3>
                                <Suspense fallback={<div className="text-center py-2"><Spinner animation="border" size="sm" variant="primary" /></div>}>
                                    <TxOverview lines={window.innerWidth <= 576 ? 6 : 12} small />
                                </Suspense>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <BalanceModal handleClose={handleClose} show={show} address={address} balance={balance} />
        </div>
    );
}

export default Dashboard;